import {
  createNavigationItem,
  createNavigationMenu,
  NavigationGroupItem,
  type NavigationMenu,
} from './side-nav-items';

export const MANAGE_GROUP_FEATURES = ['billingAndSubs', 'teamAndAdmins'] as const;
export type ManageGroupFeature = (typeof MANAGE_GROUP_FEATURES)[number];

export const getManageGroupItems = (features: ManageGroupFeature[]): NavigationGroupItem[] => {
  return features.map((f) => {
    switch (f) {
      case 'billingAndSubs':
        return createNavigationItem('billingAndSubs', '/manage-account/subscription', 'local_atm');
      case 'teamAndAdmins':
        return createNavigationItem('teamAndAdmins', '/manage-account/team-members', 'people');
    }
  });
};

export const SETTINGS_GROUP_FEATURES = [
  'reviewLinks',
  'easyReviews',
  'manageTemplates',
  'dataFeeds',
  'brandKits',
  'login',
  'emailPreferences',
  'assistants',
] as const;
export type SettingGroupFeature = (typeof SETTINGS_GROUP_FEATURES)[number];

export const getSettingsGroupItems = (features: SettingGroupFeature[], baseUrl: string): NavigationMenu => {
  const children = features.map((f) => {
    switch (f) {
      case 'easyReviews':
        return createNavigationItem('easyReviews', '/settings/easy-reviews', undefined, ['/settings/easy-reviews/*']);
      case 'manageTemplates':
        return createNavigationItem('manageTemplates', '/settings/templates/manage');
      case 'dataFeeds':
        return createNavigationItem('dataFeeds', `/settings/data-feeds`);
      case 'login':
        return createNavigationItem('login', `${baseUrl}/account`, undefined, undefined, '_blank');
      case 'emailPreferences':
        return createNavigationItem('emailPreferences', '/settings/email-preferences');
      case 'reviewLinks':
        return createNavigationItem('reviewLinks', '/settings/review-links');
      case 'assistants':
        return createNavigationItem('assistants', '/settings/assistants');
      case 'brandKits':
        return createNavigationItem('brandKits', '/settings/brand-kits');
    }
  });

  return createNavigationMenu('account', 'settings', children);
};
